/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdrop.vue?vue&type=template&id=815cf510&scoped=true"
import script from "./popAirdrop.vue?vue&type=script&lang=js"
export * from "./popAirdrop.vue?vue&type=script&lang=js"
import style0 from "./popAirdrop.vue?vue&type=style&index=0&id=815cf510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815cf510",
  null
  
)

export default component.exports